import React, { useEffect } from 'react';
import Loader from '../components/loader/Loader';
import { useCommon } from '../store/CommonContext';
import { useNavigate, useLocation } from 'react-router-dom';

interface Props {}

const LoaderView: React.FC<Props> = () => {
  const {
    state: { configuration, orderData },
  } = useCommon();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (configuration && orderData) {
      if (orderData?.result === 'CONDITIONAL_CONSUMER_INTERACTION') {
        console.log('test---4');
        navigate({
          pathname: '/challenge',
          search: location?.search,
        });
      } else if (configuration) {
        navigate({
          pathname: `/${configuration?.consentFlowConfiguration || 2}`,
          search: location?.search,
        });
      }
    }
  }, [configuration, orderData]);

  return <Loader />;
};

export default LoaderView;
